<template>
  <RevCard class="m-52 flex items-center justify-center p-52">
    <div class="flex-1">
      <div class="heading-1 mb-4">{{ i18n(translations.blockTitle) }}</div>
      <div class="body-1">{{ i18n(translations.blockDescription) }}</div>
    </div>

    <RevIllustration
      :alt="i18n(translations.blockTitle)"
      :height="130"
      size="130px"
      src="/img/no-access/no-access.png"
      :width="130"
    />
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './NoAccess.translations'

const i18n = useI18n()
</script>
